export default __webpack_public_path__ + "static/media/rentCategoryImage.cd9f0150.jpg";